import 'whatwg-fetch';
import { createGlobalStyle, css, StyleSheetManager } from 'styled-components';
import reactToastifyStyles from 'react-toastify/dist/ReactToastify.css?raw';
import Design from 'r/Design';
import Root from './Root';
import ColorThemeProvider from './ColorThemeProvider';
import './tailwind.css';

const ReactToastifyStyles = createGlobalStyle`${reactToastifyStyles}`;

const GlobalStyle = createGlobalStyle`
    ${css`
      #root {
        width: 100%;
      }
      .tooltip_box {
        box-shadow: rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;
      }
      .introjs-tooltip-header {
        padding-top: 0;
        visibility: hidden;
      }
      .introjs-helperLayer {
        width: unset !important;
        opacity: 0.2 !important;
      }
      .introjs-tooltip {
        min-width: 312px;
      }
      .introjs-tooltiptext {
        padding: 16px 16px 20px;
      }

      * {
        box-sizing: border-box;
      }

      body {
        margin: 0;
        font-variant-ligatures: none;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        -webkit-font-smoothing: antialiased;
        -webkit-text-size-adjust: 100%;
        -webkit-tap-highlight-color: transparent;
      }
    `}
  `;

export default function Main() {
  return (
    <StyleSheetManager enableVendorPrefixes>
      <Design />
      <ReactToastifyStyles />
      <GlobalStyle />
      <ColorThemeProvider>
        <Root />
      </ColorThemeProvider>
    </StyleSheetManager>
  );
}
